module.exports = __webpack_public_path__ + "img/img401.acf82b66.png";